// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__kBrb+","spinner":"Spinner_spinner__4irbY","spinner-aib1d7":"Spinner_spinner-aib1d7__e25fJ"};